import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyDynamicRadioButton(props) {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState(props.question);
  const [optionsList, setOptionsList] = useState(question.optionList);
  console.log(props);

  const [value, setValue] = useState('');
  const [remark, setRemark] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (event) => {
    setValue(event.target.value);
    const choosenOption = optionsList.find(option => option.dynamicOptionId === event.target.value);
    setSelectedOption(choosenOption);

    //Reset the remark
    var remarks = "";
    setRemark(remarks);

    buildPayload(choosenOption);
  };

  const handleRemarkChange = (event) => {
      setRemark(event.target.value);

      buildPayload(selectedOption);
  };

  const buildPayload = (choosenOption) => {
    var payload = {
      id: question.id
    };

    if (choosenOption) {
      payload = {
        id: question.id, // Assuming this is the question ID
        answerList: [
          {
            dynamicOptionId: choosenOption.dynamicOptionId,
            questionOptionId: choosenOption.id,
            answerDescription: choosenOption.name,
            remark: choosenOption.showRemark ? remark : '',
          }
        ]
      };
    }

    console.log(payload);
    dispatch(setQuestionAnswerList(payload));
};

return (
  <FormControl>
    <RadioGroup
      aria-labelledby="demo-controlled-radio-buttons-group"
      name="controlled-radio-buttons-group"
      value={value}
      onChange={handleChange}
    >
      {optionsList.map((option, index, optionsArray) => (
        <FormControlLabel
          key={option.dynamicOptionId}
          value={option.dynamicOptionId}
          control={<Radio color="success" />}
          label={option.name}
          id={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId}
          className={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId}
          name={"questionList[" + question.questionSequenceNo + "].answerList[" + index + "].questionOptionId"}
        />
      ))}
    </RadioGroup>

    {selectedOption && selectedOption.showRemark && (
        <Form.Control as="textarea"
            id={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
            className={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
            name={"questionList[" + question.questionSequenceNo + "].answerList[" + selectedOption.optionSequenceNo + "].remark"}
            placeholder="Remark"
            variant="outlined"
            value={remark}
            onChange={handleRemarkChange}
        />
    )}
  </FormControl>
); 

}
